import mqtt, { MqttClient } from 'mqtt';

let client: MqttClient;
const origin = import.meta.env.VITE_MQTT_ORIGIN ?? '';
const brokerUrl = import.meta.env.VITE_BROKER_URL ?? '';

const topicCallbacks: {
  [topic: string]: ((topic: string, message: Uint8Array) => void)[];
} = {};

export function getMqttClient(): MqttClient {
  if (!client) {
    client = mqtt.connect(brokerUrl, { protocolVersion: 5 as const });

    client.on('message', (receivedTopic, message) => {
      const originalTopic = receivedTopic.replace(origin, '');
      Object.entries(topicCallbacks).forEach(([subTopic, callbacks]) => {
        const base = subTopic.replace('#', '');
        if (receivedTopic.startsWith(`${origin}${base}`)) {
          callbacks.forEach(cb => cb(originalTopic, message));
        }
      });
    });
  }

  return client;
}

export function subscribe(
  topic: string,
  callback: (topic: string, message: Uint8Array) => void,
) {
  const fullTopic = `${origin}${topic}`;
  const mqttClient = getMqttClient();

  if (!topicCallbacks[topic]) {
    topicCallbacks[topic] = [];
    mqttClient.subscribe(fullTopic, err => {
      if (err) console.error(`Failed to subscribe to ${fullTopic}`, err);
    });
  }

  // Adiciona o callback se ele ainda não estiver na lista para este tópico
  if (!topicCallbacks[topic].includes(callback)) {
    topicCallbacks[topic].push(callback);
  }
}

export function unsubscribe(
  topic: string,
  callback: (topic: string, message: Uint8Array) => void,
) {
  if (topicCallbacks[topic]) {
    topicCallbacks[topic] = topicCallbacks[topic].filter(cb => cb !== callback);

    if (topicCallbacks[topic].length === 0) {
      const fullTopic = `${origin}${topic}`;
      const mqttClient = getMqttClient();
      mqttClient.unsubscribe(fullTopic);
      delete topicCallbacks[topic];
    }
  }
}

export const publish = (
  topic: string,
  message: string,
  callback?: (err?: Error) => void,
) => {
  const fullTopic = `${origin}${topic}`;
  const client = getMqttClient();

  try {
    const parsed = JSON.parse(message);
    if (parsed?.provisional) {
      sessionStorage.setItem('pendingProvisionalId', parsed.provisional);
      sessionStorage.setItem(
        `createdAt:${parsed.provisional}`,
        new Date().toISOString(),
      );
      sessionStorage.setItem(`messageSent:${parsed.provisional}`, 'true');
    }
  } catch (err) {
    console.error(err);
  }

  const token = localStorage.getItem('token');

  const options: mqtt.IClientPublishOptions = {
    properties: {
      userProperties: {
        token: `Bearer ${token}`,
      },
    },
  };

  client.publish(fullTopic, message, options, callback);
};
